<template>
  <ClientOnly>
    <button
      type="button"
      :aria-label="isDark ? 'Switch to light theme' : 'Switch to dark theme'"
      :title="isDark ? 'Light mode' : 'Dark mode'"
      @click="toggleTheme"
      class="flex items-center justify-center w-8 h-8 rounded-full text-gray-600 hover:text-primary hover:bg-gray-100 border-none bg-transparent cursor-pointer transition-colors"
    >
      <i v-if="isDark" class="fa fa-sun-o text-lg" aria-hidden="true"></i>
      <i v-else class="fa fa-moon-o text-lg" aria-hidden="true"></i>
    </button>
    <!-- Placeholder keeps header layout stable before hydration -->
    <template #fallback>
      <span class="inline-block w-8 h-8"></span>
    </template>
  </ClientOnly>
</template>

<script setup>
const colorMode = useColorMode();

const isDark = computed(() => colorMode.value === "dark");

const toggleTheme = () => {
  colorMode.preference = isDark.value ? "light" : "dark";
};
</script>
